/*
 * @Description:
 * @Author: xiawenlong
 * @Date: 2022-11-14 16:27:02
 * @LastEditors: xiawenlong
 * @LastEditTime: 2024-09-26 15:54:25
 */
import config from './config/system'
import axios from '@/utils/request'
export const getAllRole = params => axios.post(config.allRole, params) //全部角色
export const getAddRole = params => axios.post(config.addRole, params) //添加角色
export const getEditRole = params => axios.post(config.editRole, params) //编辑角色
export const getBatchDelRole = params => axios.post(config.batchDelRole, params) //删除角色
export const roleMenu = params => axios.post(config.roleMenu, params) //角色授权tree
export const getRoleJurisdiction = params => axios.post(config.roleJurisdiction, params) //查詢角色角色权限
export const getSureJurisdiction = params => axios.post(config.sureJurisdiction, params) //确定授权
export const getAdminList = params => axios.post(config.adminList, params) //管理员列表
export const adminDelete = params => axios.post(config.adminDelete, params) //批量删除管理员
export const getAdminAddSubmit = params => axios.post(config.adminAdd, params) //管理员添加
export const userMarkList = params => axios.post(config.userMarkList, params)
export const userMarkAdd = params => axios.post(config.userMarkAdd, params)
export const userMarkDelete = params => axios.post(config.userMarkDelete, params)
export const userRoleList = params => axios.post(config.userRoleList, params)
export const roleList = params => axios.post(config.roleList, params)
export const proctorList = params => axios.post(config.proctorList, params)
export const proctorAdd = params => axios.post(config.proctorAdd, params)
export const proctorDelete = params => axios.post(config.proctorDelete, params)
export const jonWorkTypeList = params => axios.post(config.jonWorkTypeList, params)
export const jonWorkTypeBind = params => axios.post(config.jonWorkTypeBind, params)
export const markPlanList = params => axios.post(config.markPlanList, params)
export const markBind = params => axios.post(config.markBind, params)
export const adminNewAdd = params => axios.post(config.adminNewAdd, params) //添加管理员
export const getUserAdmin = params => axios.post(config.userAdmin, params)
export const filterPlan = params => axios.post(config.filterPlan, params)
export const filterPlanSubject = params => axios.post(config.filterPlanSubject, params)
export const proctorPlan = params => axios.post(config.proctorPlan, params)
export const proctorRemove = params => axios.post(config.proctorRemove, params)
export const haha = params => axios.post(config.haha, params)
export const paperAnsAdd = params => axios.post(config.paperAnsAdd, params)
export const paperAnsList = params => axios.post(config.paperAnsList, params)
export const xixi = params => axios.post(config.xixi, params)
